export const init = async (sendAndWaitWs, scopeId) => {
  try {
    const request = {
      scopeId,
    };

    const response = await sendAndWaitWs("/chat/init", JSON.stringify(request));
    if (response.error) {
      console.log(response);
      return null;
    }
    return JSON.parse(response.payload);
  } catch (error) {
    return null;
  }
};

export const wakeWordList = async (apiCall, scopeId) => {
  const response = await apiCall(
    `/assistant/wakeWord/list?scopeId=${scopeId}`,
    "GET"
  );
  return response || response.success;
};
